<!--
 * @Date: 2024-05-15 15:14:31
 * @LastEditTime: 2024-05-21 10:13:10
-->
<template>
  <Header
    :leftArrow="true"
    :leftText="''"
    @leftClick="
      () => {
        router.push('/dashBoard');
      }
    "
    @rightAdd="
      () => {
        router.push('/roomAdd');
      }
    "
    :rightIcons="true"
    :right-add="true"
  />

  <div
    class="home room watch_movie"
    style="position: relative; max-height: 100%"
  >
<!--    style="position: sticky; top: 0px; z-index: 2"-->
    <div
      class="home_notice-search"
    >
      <form>
        <input
          type="search"
          name="searchInput"
          placeholder="ルームを検索"
          v-model="searchValue"
        />
        <input
          type="submit"
          name="submit"
          value="検索"
          onclick="return false;"
        />
      </form>
    </div>

    <div class="watch_wrap" style="height: 100%">
      <div class="room-list">
        <div
          class="movie-item room-item"
          v-for="room in rooms"
          :key="room.id"
          v-show="room.name.includes(searchValue)"
        >
          <p @click="onOpenSchedule(room)" class="room-item_name">
            {{ room.name }}
          </p>
          <button class="movie-remove-btn room-remove-btn" @click.stop>
            <img
              src="@/assets/img/home/icon_remove.png"
              alt=""
              @click="onOpenRoom(room.room_id)"
            />
          </button>
          <div
            class="room-select-pop"
            :class="[room.room_id === clickRoomId ? 'open' : '']"
          >
            <a @click="onEditRoom(room)" class="movie-edit-pop">編集</a>
            <a @click="onDeleteRoom(room)" class="movie-remove-pop">削除</a>
          </div>
        </div>
      </div>
    </div>
  </div>

  <van-popup
    v-if="isScheduleDialog"
    v-model:show="isScheduleDialog"
    position="bottom"
    style="height: 95%; background-color: rgb(244, 251, 255)"
  >
    <div
      style="
        position: relative;
        padding-top: 2rem;
        margin: 0 auto;
        width: 95% !important;
      "
    >
      <Schedule
        :action="{
          getOtherParams: () => {
            return { roomId: clickRoom.room_id, roomName: clickRoom.name };
          },
        }"
        :events="events"
        :schedules="clickRoom.schedules"
        :isRoom="true"
      />
    </div>
  </van-popup>
</template>

<script setup>
import Header from "@/components/Header.vue";
import Schedule from "@/components/Schedule.vue";
import { onMounted, ref, computed, watch } from "vue";
import { useRouter, useRoute } from "vue-router";
import { GetRooms, DeleteRoom } from "@/services/room";
import { Toast, Dialog } from "vant";
const router = useRouter();
const { query } = useRoute();

const searchValue = ref("");
const rooms = ref([]);
// clickRoom 用于日历弹出 clickRoomId用于弹出操作框
const clickRoom = ref();
const clickRoomId = ref();
const isScheduleDialog = ref(false);
const userInfo = computed(() => {
  return JSON.parse(localStorage.getItem(process.env.VUE_APP_USER_KEY)) || {};
});
const onEditRoom = ({ id, room_id, isCreatedUser }) => {
  try {
    if (isCreatedUser !== "yes") {
      clickRoomId.value = null;
      return Toast.fail("作成者ではなく、操作権限がありません。");
    }
    router.push({
      path: "/roomEdit",
      query: {
        id,
        room_id,
      },
    });
  } catch (error) {
    console.error(error);
  }
};
const onDeleteRoom = async ({ isCreatedUser }) => {
  try {
    if (isCreatedUser !== "yes") {
      return Toast.fail("作成者ではなく、操作権限がありません。");
    }
    try {
      await Dialog.confirm({
        title: "このルームを削除しますか？",
      });
      const {
        data: { code },
      } = await DeleteRoom({ ids: [clickRoomId.value] });
      rooms.value = rooms.value.filter((r) => r.room_id !== clickRoomId.value);
      clickRoomId.value = null;
      if (code >= 0) {
        Toast("削除に成功しました。");
      } else {
        Toast("削除に失敗しました。");
      }
    } catch (error) {
      console.error(error);
      clickRoomId.value = null;
    }
  } catch (error) {
    console.error(error);
  }
};

const onOpenRoom = (id) => {
  clickRoomId.value = clickRoomId.value === id ? null : id;
};
const getRooms = async () => {
  try {
    const {
      data: { data },
    } = await GetRooms();
    rooms.value = data;
  } catch (error) {
    console.error(error);
  }
};

const events = computed(() => {
  return clickRoom.value
    ? clickRoom.value?.schedules.map((s) => ({
        id: s.roomyotei_id,
        title: s.yotei_name,
        start: s.start_time,
        end: s.end_time,
        color:
          userInfo.value.login_account_id === s.updated_by
            ? "rgb(199,228,252)"
            : "rgb(255,234,204)",
        editable: false,
        overlap: true,
      }))
    : [];
});
const onOpenSchedule = async (selectRoom) => {
  try {
    clickRoom.value = selectRoom;
    isScheduleDialog.value = true;
  } catch (error) {
    console.error(error);
  }
};

onMounted(async () => {
  try {
    await getRooms();
    if (query?.roomId && query?.roomName) {
      if (rooms.value.find((v) => v.room_id === query.roomId))
        onOpenSchedule(rooms.value.find((v) => v.room_id === query.roomId));
    }
  } catch (error) {
    console.error(error);
  }
});
</script>

<style lang="less">
.content {
  height: 100%;
  padding: 15px 0;
  background-color: "#F4FBFF";
}
</style>
